import { Avatar } from "@design";
import { Text } from "@/components/Text";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { initialsOf } from "@/lib/initials";

export function ProfileSummary() {
  const user = useCurrentUser().data?.user;
  if (!user) return null;
  return (
    <div className="flex items-center gap-4">
      <Avatar initials={initialsOf(user.name)} src={user.avatarUrl ?? undefined} size="lg" />
      <div className="flex min-w-0 flex-col">
        <Text as="span" variant="h3" className="truncate">
          {user.name}
        </Text>
        <Text as="span" variant="body-sm" tone="secondary" className="truncate">
          {user.email}
        </Text>
      </div>
    </div>
  );
}
